import { PrivilegeKey } from "~/types";

// Checks whether a known privilege key is present in a list of privileges returned by the API, returning a plain boolean
export const hasPrivilege = (
  privileges: Array<{ key: string } | null | undefined> | null | undefined,
  key: PrivilegeKey
): boolean => Boolean(privileges?.some(p => p?.key === key));
